import React from 'react';
import { useTranslation } from 'react-i18next';

import { usePlanStatus } from '../../../hooks/usePlanStatus';
import { PlanIcon } from '../../../utils/planDisplay';
import { formatPlanTimelineLocalized, getLocalizedPlanLabel } from '../../../utils/planI18n';

interface ProfilePlanCardProps {
  onUpgradeClick: () => void;
}

/** Plan summary for profile menus — plan type only (credits live in the top bar). */
const ProfilePlanCard: React.FC<ProfilePlanCardProps> = ({ onUpgradeClick }) => {
  const { t, i18n } = useTranslation();
  const planStatus = usePlanStatus();
  const label = getLocalizedPlanLabel(planStatus.planKey, t);
  const timeline = formatPlanTimelineLocalized(
    t,
    planStatus.periodEnd,
    planStatus.daysLeft,
    planStatus.isExpired,
    i18n.language,
  );
  const showUpgrade =
    planStatus.planKey === 'free'
    || planStatus.isOutOfCredits
    || planStatus.isExpired
    || planStatus.planKey === 'monthly'
    || planStatus.planKey === 'quarterly';

  return (
    <div
      className="mx-3 my-2 rounded-lg border p-2.5"
      style={{ borderColor: 'var(--ds-border)', background: 'var(--ds-bg-subtle, #f8fafc)' }}
    >
      <div className="flex items-center justify-between gap-2">
        <div className="flex min-w-0 items-center gap-2">
          <PlanIcon planId={planStatus.planId} planKey={planStatus.planKey} size={15} />
          <div className="min-w-0">
            <span className="t-body t-strong truncate block">{label}</span>
            {timeline && (
              <span className="t-meta t-muted truncate block">{timeline}</span>
            )}
          </div>
        </div>
        {showUpgrade && (
          <button
            type="button"
            onClick={onUpgradeClick}
            className="shrink-0 t-meta font-semibold hover:underline"
            style={{ color: 'var(--ds-brand)' }}
          >
            {planStatus.planKey === 'free'
              ? t('layout.profile.upgrade', 'Upgrade')
              : t('layout.profile.changePlan', 'Change plan')}
          </button>
        )}
      </div>
    </div>
  );
};

export default ProfilePlanCard;
